import { PreventScroll, ShouldPreventScroll } from '@/v1/components/utils/DeviceUtils';

const PlatformController = () => {
    if (ShouldPreventScroll()) {
        PreventScroll();
    }
};

export default PlatformController;
